<template>
  <div class='WorkSpace'>
    <adm-top/>
    <router-view/>
  </div>
</template>

<script>
import AdmTop from './top/AdmTop'
export default {
  name: 'WorkSpace',
  components: { AdmTop }
}
</script>

<style scoped>
.WorkSpace {
  width: 100%;
  height: 100%;
}
</style>
